/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Services
import { filterCampusVirtual, requestGetAllCampus } from "services/general";
import { requestGetSpaceTypes, requestGetUniversityActivities } from "services/resources/universitySpaces/relatedToUniversitySpaceResources";
//#endregion
//#region Utils
import useMainContext from "utils/context/useMainContext";
//#endregion

const useDataRelatedToSpaceAdmin = ({
    loadingRequest
}) => {
    const mainContext = useMainContext();
    //#region States
    const [campusList, setCampusList] = useState([]);
    const [spaceTypeList, setSpaceTypeList] = useState([]);
    const [universityActivityList, setUniversityActivityList] = useState([]);
    //#endregion
    //#region Effects
    useEffect(() => {
        fillData();
    }, []);
    //#endregion
    //#region Functions
    const fillData = async () => {
        loadingRequest.show();
        try {
            let requests = [
                fillCampusList(),
                fillUniversityActivityList(),
                fillSpaceTypeList()
            ];
            await Promise.all(requests);
        }
        catch (err) {
            mainContext.setShowDialogUnexpectedError(true);
        }
        finally {
            loadingRequest.hide();
        }
    }
    const fillCampusList = async () => {
        const data = await requestGetAllCampus();
        setCampusList(filterCampusVirtual(data));
    }
    const fillSpaceTypeList = async () => {
        const data = await requestGetSpaceTypes();
        setSpaceTypeList(data);
    }
    async function fillUniversityActivityList() {
        const fetchData = await requestGetUniversityActivities();
        setUniversityActivityList(fetchData);
    }
    //#endregion
    return {
        campusList,
        spaceTypeList,
        universityActivityList
    };
}

export default useDataRelatedToSpaceAdmin;